import { AdminBadge } from "./AdminBadge";

// Centralizes the status->color mapping so every page that shows order
// status, active/inactive, or stock level agrees on what each color means
// instead of each page inventing its own mapping (Orders.jsx used to
// define this map locally with no equivalent anywhere else).
export const ORDER_STATUS_VARIANT = {
  "Order Pending": "warning",
  "On The way to deliver": "purple",
  "Under Package": "info",
  "Deliverd": "success",
  "Canceled": "danger",
};

export const ACTIVE_VARIANT = { true: "success", false: "neutral" };

export function stockVariant(quantity) {
  if (quantity === 0) return "danger";
  if (quantity <= 5) return "warning";
  return "success";
}

export function stockLabel(quantity) {
  if (quantity === 0) return "Out of stock";
  if (quantity <= 5) return `${quantity} left`;
  return `${quantity} in stock`;
}

export const AdminStatusBadge = ({ status, map, fallbackVariant = "neutral", children }) => {
  const variant = (map && map[status]) || fallbackVariant;
  return <AdminBadge variant={variant}>{children ?? status}</AdminBadge>;
};
